import React, { useEffect, useState } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import styles from './Partners.module.css';
import { useNavigate } from 'react-router-dom';

const fadeAnimationHandler = (props, state) => {
  const transitionTime = props.transitionTime + 'ms';
  const transitionTimingFunction = 'ease-in-out';

  let slideStyle = {
    position: 'absolute',
    display: 'block',
    minHeight: '100%',
    opacity: 0,
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    transitionTimingFunction: transitionTimingFunction,
    msTransitionTimingFunction: transitionTimingFunction,
    MozTransitionTimingFunction: transitionTimingFunction,
    WebkitTransitionTimingFunction: transitionTimingFunction,
    OTransitionTimingFunction: transitionTimingFunction,
  };

  if (!state.swiping) {
    slideStyle = {
      ...slideStyle,
      WebkitTransitionDuration: transitionTime,
      MozTransitionDuration: transitionTime,
      OTransitionDuration: transitionTime,
      transitionDuration: transitionTime,
      msTransitionDuration: transitionTime,
    };
  }

  return {
    slideStyle,
    selectedStyle: {
      ...slideStyle,
      opacity: 1,
      position: 'relative',
    },
    prevStyle: {
      ...slideStyle,
      opacity: 0, // Fade out the previous slide
    },
  };
};

const Partners = () => {
  const navigate = useNavigate();
  // Define your handleButtonClick function
  const handleButtonClick = async (buttonNumber) => {
    try {
      // Find the partner data based on the buttonNumber
      const partner = data[buttonNumber - 1];

      if (partner) {


        navigate(`/partnersDetails?id=${partner.partnerName}`, {
          state: {
            partnerName: partner.partnerName,
            LogoimageSrc: partner.LogoimageSrc,
            image1Src: partner.image1Src,
            image2Src: partner.image2Src,
            videoSrc: partner.videoSrc,
            videoThumbnail: partner.videoThumbnail,
            info: partner.info
          }
        });
      } else {
        console.error(`Partner not found for button number ${buttonNumber}`);
      }
    } catch (error) {
      console.error(error);
      // Handle the error as needed
    }
  };

  const sectors = [
    'Page1',
    'Page2',

  ];




  const data = [
    {
      partnerName: 'Toy & Joy',
      buttonNumber: 1,
      LogoimageSrc: '/Partners/Toy & Joy/logo.png',
      image1Src: '/Partners/Toy & Joy/1.jpg',
      image2Src: '/Partners/Toy & Joy/2.jpg',
      videoSrc: '/Partners/Toy & Joy/video.mp4',
      videoThumbnail: '/Partners/Toy & Joy/videoThumbnail.jpg',
      info: "Founded in 2011, Toy & Joy specializes in selling children's toys and educational materials such as number and letter learning toys.The company has multiple branches."
    }
    ,
    {
      partnerName: '2M Group',
      buttonNumber: 2,
      LogoimageSrc: '/Partners/2M Group/logo.png',
      image1Src: '/Partners/2M Group/1.jpg',
      image2Src: '/Partners/2M Group/2.jpg',
      videoSrc: '/Partners/2M Group/video.mp4',
      videoThumbnail: '/Partners/2M Group/videoThumbnail.jpg',
      info: 'Founded in 2011, 2M Group is a company specializing in printing services and related supplies. It serves various clients, including Art Media and Media Print.'
    }
    ,
    {
      partnerName: 'Al Eman',
      buttonNumber: 3,
      LogoimageSrc: '/Partners/Al Eman/logo.png',
      image1Src: '/Partners/Al Eman/1.jpg',
      image2Src: '/Partners/Al Eman/2.jpg',
      videoSrc: '/Partners/Al Eman/video.mp4',
      videoThumbnail: '/Partners/Al Eman/videoThumbnail.jpg',
      info: 'Established in 2017, Al Eman Plastic Factory is one of the leading manufacturers in plastic blow molding, producing barrels, jerry cans, and the latest types of chairs and tables in various sizes, shapes, cultures, weights, colors, and international specifications, serving all industries.'
    }
    ,
    {
      partnerName: 'Merco Market',
      buttonNumber: 4,
      LogoimageSrc: '/Partners/Merco Market/logo.png',
      image1Src: '/Partners/Merco Market/1.jpg',
      image2Src: '/Partners/Merco Market/2.jpg',
      videoSrc: '/Partners/Merco Market/video.mp4',
      videoThumbnail: '/Partners/Merco Market/videoThumbnail.jpg',
      info: 'Founded in 2016, Merco Market specializes in manufacturing feed additives and organic fertilizers. Its key clients include Al Madina Trading Company and Venus Company. The company holds all necessary licenses.'
    }
    ,
    {
      partnerName: 'Al Masrya Foam',
      buttonNumber: 5,
      LogoimageSrc: '/Partners/Al Masrya Foam/logo.png',
      image1Src: '/Partners/Al Masrya Foam/1.jpg',
      image2Src: '/Partners/Al Masrya Foam/2.jpg',
      videoSrc: '/Partners/Al Masrya Foam/video.mp4',
      videoThumbnail: '/Partners/Al Masrya Foam/videoThumbnail.jpg',
      info: 'Established in 2016, Al Masrya Foam specializes in manufacturing and distributing industrial sponge products in various densities. The company employs numerous technicians to produce high-quality mattresses. They have also launched another brand under Al Masrya Foam called "Cloud Bed," which offers high-quality mattresses. The factory is equipped with advanced machinery and equipment for producing the best materials.'
    }
    ,
    {
      partnerName: 'Golden Power',
      buttonNumber: 6,
      LogoimageSrc: '/Partners/Golden Power/logo.png',
      image1Src: '/Partners/Golden Power/1.jpg',
      image2Src: '/Partners/Golden Power/2.jpg',
      videoSrc: '/Partners/Golden Power/video.mp4',
      videoThumbnail: '/Partners/Golden Power/videoThumbnail.jpg',
      info: 'Founded in 2015, Golden Power is involved in the distribution and trade of oils and lubricants. It has multiple branches across Egyptian governorates and owns a fleet of vehicles for delivery and supply of its products. The company is currently expanding and constructing a factory for automotive oil packaging.'
    }
    ,
    {
      partnerName: 'Maka',
      buttonNumber: 7,
      LogoimageSrc: '/Partners/Maka/logo.png',
      image1Src: '/Partners/Al Shorouq/1.jpg',
      image2Src: '/Partners/Al Shorouq/2.jpg',
      videoSrc: '/Partners/Al Shorouq/video.mp4',
      videoThumbnail: '/Partners/Al Shorouq/videoThumbnail.jpg',
      info: 'Makkah Food was established in 2019 and operates in the frozen meat sales sector. The company sells and distributes its products to global companies such as Cairo Poultry Slaughterhouses (Cooky), as well as other companies like Silva for foodstuffs.'
    },
    {
      partnerName: 'Happy Stars',
      buttonNumber: 8,
      LogoimageSrc: '/Partners/Happy Stars/logo.png',
      image1Src: '/Partners/Happy Stars/1.jpg',
      image2Src: '/Partners/Happy Stars/2.jpg',
      videoSrc: '/Partners/Happy Stars/video.mp4',
      videoThumbnail: '/Partners/Happy Stars/videoThumbnail.jpg',
      info: 'Founded in 2007, Happy Stars engages in the trade and distribution of food products. The company serves numerous clients across Egyptian governorates due to the continuous demand for food items. It also serves markets in Upper Egypt and owns a fleet of vehicles to support its operations.'
    }
    ,
    {
      partnerName: 'Arafa Truck',
      buttonNumber: 9,
      LogoimageSrc: '/Partners/Arafa Truck/logo.png',
      image1Src: '/Partners/Arafa Truck/1.jpg',
      image2Src: '/Partners/Arafa Truck/2.jpg',
      videoSrc: '/Partners/Arafa Truck/video.mp4',
      videoThumbnail: '/Partners/Arafa Truck/videoThumbnail.jpg',
      info: 'Founded in 2009, Arafa Truck offers tailored solutions for all logistics operations. The company specializes in leasing and selling a wide range of equipment. Additionally, it provides maintenance services and staffing solutions to assist construction and contracting companies in their operations.'
    }
    ,
    {
      partnerName: 'Food Service',
      buttonNumber: 10,
      LogoimageSrc: '/Partners/Food Service/logo.png',
      image1Src: '/Partners/Food Service/1.jpg',
      image2Src: '/Partners/Food Service/2.jpg',
      videoSrc: '/Partners/Food Service/video.mp4',
      videoThumbnail: '/Partners/Food Service/videoThumbnail.jpg',
      info: 'Founded in 2014, Food Service is involved in the production and distribution of food products. The company has multiple production lines and owns a fleet of vehicles for product distribution. Its products include white vinegar, apple vinegar, pomegranate molasses, rose water, citric acid, basmati rice, oats, and many other items.'
    }
    ,
    {
      partnerName: 'Neslo',
      buttonNumber: 11,
      LogoimageSrc: '/Partners/Neslo/logo.png',
      image1Src: '/Partners/Hesham Tyres/1.jpg',
      image2Src: '/Partners/Hesham Tyres/2.jpg',
      videoSrc: '/Partners/Hesham Tyres/video.mp4',
      videoThumbnail: '/Partners/Hesham Tyres/videoThumbnail.jpg',
      info: 'Neslo Company was established in 2020 and operates in the activity of packaging various food products. The company holds an organic certification from the Chamber of Food Industries and has several vehicles to support its operations across the provinces of Egypt.'
    },
    {
      partnerName: 'Heslo',
      buttonNumber: 12,
      LogoimageSrc: '/Partners/Heslo/logo.png',
      image1Src: '/Partners/Heslo/1.jpg',
      image2Src: '/Partners/Heslo/2.jpg',
      videoSrc: '/Partners/Heslo/video.mp4',
      videoThumbnail: '/Partners/Heslo/videoThumbnail.jpg',
      info: 'Founded in 1995, Heslo Blinds operates numerous branches alongside its factory, specializing in various types of home automation known as smart homes. The company manufactures a wide range of automated curtains, theaters, roller shutters, conservatories, tents, garage doors, and gates in modern, classic, and trendy colors. Heslo makes home control simple and offers a complete home automation experience.'
    }
    ,
    {
      partnerName: 'International Textile',
      buttonNumber: 13,
      LogoimageSrc: '/Partners/International Textile/logo.png',
      image1Src: '/Partners/International Textile/1.jpg',
      image2Src: '/Partners/International Textile/2.jpg',
      videoSrc: '/Partners/International Textile/video.mp4',
      videoThumbnail: '/Partners/International Textile/videoThumbnail.jpg',
      info: 'International Textile was founded in 2008. The company owns complete production lines for spinning, weaving, dyeing, printing, and finishing. It is known for manufacturing high-quality polyester materials and is a pioneer in the yarn and textile industry in Egypt. The company specializes in fine cotton, polyester, and blended fabrics, excelling in dyeing, printing, and finishing. It offers high-quality printing that aligns with the latest fashion trends.'
    }
    ,
    {
      partnerName: 'Metal Tech',
      buttonNumber: 14,
      LogoimageSrc: '/Partners/Metal tech/logo.png',
      image1Src: '/Partners/Metal tech/1.jpg',
      image2Src: '/Partners/Metal tech/2.jpg',
      videoSrc: '/Partners/Metal tech/video.mp4',
      videoThumbnail: '/Partners/Metal tech/videoThumbnail.jpg',
      info: 'Founded in 2018, Metal Tech is involved in manufacturing, trading, and supplying electrical fittings, electrical panels, components, and cable trays of all types. The company has its own manufacturing facility and offers the ability to design various electrical panels as per consumer needs.'
    }
    ,
    {
      partnerName: 'Porsh',
      buttonNumber: 15,
      LogoimageSrc: '/Partners/porsh/logo.png',
      image1Src: '/Partners/Porsh/1.jpg',
      image2Src: '/Partners/Porsh/2.jpg',
      videoSrc: '/Partners/Porsh/video.mp4',
      videoThumbnail: '/Partners/Porsh/videoThumbnail.jpg',
      info: 'Founded in 1997, Porsh Technology specializes in selling its own brand of personal computers known as GME PC, distributing computer components, designing and implementing computer networks, and providing maintenance services. The company collaborates with major computer service companies like RadioShack, Computer Shop, and Byte.'
    }
    ,
    {
      partnerName: 'Power Pack',
      buttonNumber: 16,
      LogoimageSrc: '/Partners/Power Pack/logo.png',
      image1Src: '/Partners/Power Pack/1.jpg',
      image2Src: '/Partners/Power Pack/2.jpg',
      videoSrc: '/Partners/Power Pack/video.mp4',
      videoThumbnail: '/Partners/Power Pack/videoThumbnail.jpg',
      info: 'Founded in 2019, Power Pack Factory owns 7 production lines. Its products are known for high quality, made from cotton, polyester, and linen, with reinforced stitching throughout. These bags are extremely durable for daily use, offering ample capacity to easily meet your daily needs.'
    }
    ,
    {
      partnerName: 'Royal Palace',
      buttonNumber: 17,
      LogoimageSrc: '/Partners/Royal Palace/logo.png',
      image1Src: '/Partners/Royal Palace/1.jpg',
      image2Src: '/Partners/Royal Palace/2.jpg',
      videoSrc: '/Partners/Royal Palace/video.mp4',
      videoThumbnail: '/Partners/Royal Palace/videoThumbnail.jpg',
      info: 'Founded in 2021, Royal Palace is a leading company in the field of manufacturing household furniture in all its forms. Established on a 25,000 square meter area in addition to large external warehouses, the factory possesses numerous machines for manufacturing all types of furniture for exhibitions, offices, and household essentials.'
    }
    ,
    {
      partnerName: 'Al Sama',
      buttonNumber: 18,
      LogoimageSrc: '/Partners/Sama/logo.png',
      image1Src: '/Partners/Al Sama/1.jpg',
      image2Src: '/Partners/Al Sama/2.jpg',
      videoSrc: '/Partners/Al Sama/video.mp4',
      videoThumbnail: '/Partners/Al Sama/videoThumbnail.jpg',
      info: "Founded in 2011, Al Sama Plastic Factory specializes in manufacturing cylinders and bags from polyethylene. We also produce biodegradable bags and collaborate with French companies in the oil exploration sector. We have obtained certification from the Plastic Technology Center after conducting necessary tests to ensure the product's biodegradability under weather conditions. We have built our reputation in this field and work with major companies in the paper, metal, and plastic sectors."
    }
    ,
    {
      partnerName: 'Tyre Market',
      buttonNumber: 19,
      LogoimageSrc: '/Partners/Tyre Market/logo.png',
      image1Src: '/Partners/Tyre Market/1.jpg',
      image2Src: '/Partners/Tyre Market/2.jpg',
      videoSrc: '/Partners/Tyre Market/video.mp4',
      videoThumbnail: '/Partners/Tyre Market/videoThumbnail.jpg',
      info: 'Founded in 2015, Tyre Market specializes in selling tires and batteries for cars through several branches in Greater Cairo. The company owns multiple service centers, serving major clients such as Arab Office for Contracting, Construction Company, and Fath Contracting Company.'
    }
    ,
    {
      partnerName: 'Alghandour',
      buttonNumber: 20,
      LogoimageSrc: '/Partners/Bon Alghandour/logo.png',
      image1Src: '/Partners/Bon Alghandour/1.jpg',
      image2Src: '/Partners/Bon Alghandour/2.jpg',
      videoSrc: '/Partners/Bon Alghandour/video.mp4',
      videoThumbnail: '/Partners/Bon Alghandour/videoThumbnail.jpg',
      info: 'Established in 2004, Bon Alghandour specializes in grinding, packaging, and sealing coffee, in addition to serving hot beverages through multiple branches. The establishment serves various customers such as companies and institutions by supplying coffee to these facilities.'
    }
    ,
    {
      partnerName: 'Mansour',
      buttonNumber: 21,
      imageSrc: '/image5.png',
      info: 'Established in 2021, Mansour Construction Company is an engineering firm with a dynamic, knowledgeable, and enthusiastic team. They have extensive experience in managing industrial projects at an international level. Their wide range of services includes: - Design and construction (turnkey projects) - Project/Construction management - Construction safety management - Construction safety management auditing',
      LogoimageSrc: '/Partners/Mansour/logo.png'
    }
    ,
    { partnerName: 'El Monsef', buttonNumber: 22, imageSrc: '/image5.png', info: 'Al Monsif Company was founded in 2019 and operates in the field of ready-made garment manufacturing. The company has several contracts with major companies such as TEMA Manufacturing and manufactures for others in collaboration with Alwan, a subsidiary of the LC Waikiki group.', LogoimageSrc: '/Partners/El Monsef/logo.png' },
    {
      partnerName: 'MG',
      buttonNumber: 23,
      imageSrc: '/image5.png',
      info: 'Established in 2014, MG Pharma specializes in manufacturing pharmaceuticals and cosmetics for external use. The company has contracts with several companies for manufacturing its products, such as Amita for cosmetics, Pharma Zad, and Pharma Gen. MG Pharma also distributes its products to prominent companies like Pharma Over Seas and Ibn Sina Company.',
      LogoimageSrc: '/Partners/MG/logo.png'
    }
    ,
    {
      partnerName: 'Urgent',
      buttonNumber: 24,
      imageSrc: '/image5.png',
      info: 'Established in 1992, Urgent Egypt for Transport and Shipping operates in the field of transporting goods and parcels using various vehicles and means of transportation. The company provides its services to major entities through several branches and service vehicles to transport goods between all governorates of the Republic.',
      LogoimageSrc: '/Partners/Urgent/logo.png'
    }
    ,
    {
      partnerName: 'Master',
      buttonNumber: 25,
      imageSrc: '/image5.png',
      info: 'Established in 2017, Master for Contracting specializes in general contracting and trading building materials. The company operates multiple administrative offices to serve Egyptian governorates. It has executed construction and finishing projects in the New Administrative Capital as well as several other governorates like Sharkia and Qena.',
      LogoimageSrc: '/Partners/Master/logo.png'
    }
    , {
      partnerName: "Al Ekhwa",
      buttonNumber: 26,
      imageSrc: "/image5.png",
      info: "Established in 2014, Al Ekhwa Company specializes in various types of rolls, digitally printed bags up to 6 colors, all types of plastic bags, and ready-made printed rolls. The company is a leader in the industry of plastic rolls and bags, producing heavy-duty bags for fertilizers packaging and lightweight film bags. The company exports to European Union countries, Africa, and Lebanon.",
      LogoimageSrc: "/Partners/Al Akhwa/logo.png"
    }
    ,
    {
      partnerName: "El Manahry",
      buttonNumber: 27,
      imageSrc: "/image5.png",
      info: "Established in 2018, El Manahry Company operates in the field of manufacturing plastic mats. It serves numerous clients within and outside the Republic, adhering to all quality standards and holding a membership certificate from the Egyptian Industries Federation. El Manahry collaborates with SABIC for manufacturing plastic materials and also with Al Raie Factory for Plastics.",
      LogoimageSrc: "/Partners/Al Manahry/logo.png"
    }
    ,
    {
      partnerName: "First",
      buttonNumber: 28,
      imageSrc: "/image5.png",
      info: "Established in 2016, First Company has gained distinction among companies due to our integrity in the plastics industry and customer trust in our credibility. We participate in the market, engage in tenders, and contract with major companies. Our product is known for its quality and safety, and we continuously improve our quality through an excellent quality and safety system that meets ongoing challenges and customer requirements. ",
      LogoimageSrc: "/Partners/First/logo.png"
    }
    ,
    {
      partnerName: "Ram",
      buttonNumber: 29,
      imageSrc: "/image5.png",
      info: "Founded in 2010, Ram Company specializes in pet food manufacturing. Since its inception, the company has partnered with Mira, the German company, as its exclusive agent for all products in Egypt and the Middle East. It has subsequently secured contracts with several distinguished brands in various pet food sectors. In 2016, Ram shifted towards manufacturing, aiming to revolutionize local production of pet food using the finest materials and suitable ingredients, ensuring exceptional care for pets owned by breeders.",
      LogoimageSrc: "/Partners/Ram/logo.png"
    }
    , {
      partnerName: "Future Transport",
      LogoimageSrc: "/Partners/Future/logo.png",
      buttonNumber: 30,
      imageSrc: "/image5.png",
      info: "Founded in 2013, Future Transport provides corporate employee transportation services and rents various types of vehicles for employee transport. The company owns a fleet of vehicles dedicated to its operations. Its major clients include Libtis Egypt for Pharmaceuticals and Medical Products, GIG Egypt, and Edita Food Industries."
    }
    ,
    {
      partnerName: "Samo",
      buttonNumber: 31,
      imageSrc: "/toyjoy.svg",
      info: "Founded in 2006, Samo specializes in ready-made garments, household furnishings including covers of all kinds, production of knitting and embroidery threads. Samo is known for its unique designs.",
      LogoimageSrc: "/Partners/Samo/logo.png"
    }
    ,
    {
      partnerName: "Holandia",
      buttonNumber: 32,
      imageSrc: "/Holandia.svg",
      info: "Founded in 2019, Holandia White Gold is a leading company in the production of confectionery raw materials, chocolates, juice powders, and mix powder, as well as bio-gluten. The company serves various clients such as Tawfeeq Company and Al Madinah Al Munawwarah for Raw Materials.",
      LogoimageSrc: "/Partners/Holandia/logo.png"
    }
    ,
    {
      partnerName: "Gebalko",
      LogoimageSrc: "/Partners/Gebalko/logo.png",
      buttonNumber: 33,
      imageSrc: "/image3.png",
      info: "Established in 1984, Gebalko Egypt is one of the Egyptian companies operating in the field of contracting for over 35 years. It is registered in the records of the Egyptian Federation of Construction Contractors as a first-class contractor for integrated and finishing works. Gebalko is also registered in water and sewage networks, in addition to general works and electromechanical and electronic works.",
    }
    ,
    {
      partnerName: "Module",
      LogoimageSrc: "/Partners/Module/logo.png",
      buttonNumber: 34,
      imageSrc: "/image4.png",
      info: "Founded in 2019, Module specializes in supplying food products. Among its key clients are Goodies Egypt and Infinity Dimension for Trade and Supplies."
    }
    , {
      partnerName: "Al Kanana",
      buttonNumber: 35,
      imageSrc: "/image5.png",
      info: "Founded in 2018 in Menoufia Governorate, Al Kanana Feed Company emerged as a symbol of excellence and quality in the animal feed industry. Since its inception, Al Kanana has been committed to offering high-quality products accessible to all. It is a pioneering company in the feed industry, known for its diverse range of products catering to the needs of livestock and poultry farmers. Al Kanana Feed Company employs state-of-the-art technologies in feed production, focusing on providing various concentrates for fattening livestock.",
      LogoimageSrc: "/Partners/Al Kanana/logo.png"
    }
    ,
    {
      partnerName: "El Safier",
      buttonNumber: 36,
      imageSrc: "/image5.png",
      info: "Founded in 2017, El Safier specializes in the packaging and packaging of foodstuffs. It is one of the leading companies in the Egyptian market, accommodating various orders such as oil and sugar at the governorate level.",
      LogoimageSrc: "/Partners/Al Safir/logo.png"
    }
    ,
    {
      partnerName: "Al Saif",
      buttonNumber: 37,
      imageSrc: "/image5.png",
      info: "Al Saif Company is a leading company with extensive experience in one of the most important fields of petroleum derivatives: importing and trading plastic materials, also known as polymers. Since its inception, Al Saif has been involved in various types of plastic materials.",
      LogoimageSrc: "/Partners/Al Saif/logo.png"
    }
    , {
      partnerName: "El Khattab",
      buttonNumber: 38,
      imageSrc: "/image5.png",
      info: "Founded in 2004, El Khattab Travel specializes in transportation services for employees and staff of companies. It has multiple branches and vehicles to serve its activities. Among its key clients are City Club, Qatar National Bank in Sadat City, and Egyptian Star Tourism Company.",
      LogoimageSrc: "/Partners/Khatab/logo.png"
    }
    ,
    {
      partnerName: "A M A",
      buttonNumber: 39,
      imageSrc: "/image5.png",
      info: "Founded in 2013, Ama Transport works with global companies to transport their goods, including PepsiCo for Food Industries, Pepsi Cola Egypt, Juhayna Group, and many others. The company owns a variety of vehicles capable of transporting goods and accommodating all requests for transporting products in the Egyptian market.",
      LogoimageSrc: "/Partners/AMA/logo.png"
    }
    ,
    { partnerName: 'HF', LogoimageSrc: '/Partners/HF/logo.png', buttonNumber: 40, imageSrc: '/image5.png', info: 'Dr. Hanna Fihm Hospital, established in 2012, is one of the largest hospitals in Minya Governorate. The hospital is equipped with numerous high-quality medical devices and serves all the neighboring governorates. The hospital also boasts a team of doctors and nurses who have obtained all the necessary certifications across various specialties.' },
    {
      partnerName: "Pyramids",
      LogoimageSrc: "/Partners/Pyramids/logo.png",
      buttonNumber: 41,
      imageSrc: "/image5.png",
      info: "Founded in 2020, Pyramids specializes in manufacturing and trading iron and metals. The company collaborated with a consulting office to supply and install metal canopies for the Ministry of Interior and installed canopies for Hanimex Import and Export Company. Pyramids also performed metal works at the Cairo International Stadium in the covered hall."
    }
    , {
      partnerName: "Afrofix",
      LogoimageSrc: "/Partners/Afrofix/logo.png",
      buttonNumber: 42,
      imageSrc: "/image5.png",
      info: "Founded in 1981, Afrofix Trading and Engineering Company is the first Egyptian company specialized in manufacturing electromechanical support systems and spare parts for industrial, commercial, and public facilities. Its products include complete pipe support systems, strut clamps, bends, complete mechanical cladding fixation systems, concrete inserts, and steel framing systems. Its products have been used in numerous projects across Egypt, the Middle East, and Africa by major Egyptian contractors such as Orascom Construction OC, Arab Contractors, Hassan Allam, Redcon, Nafco, CCC, Contrack, and others."
    }
    ,
    {
      partnerName: 'Al Shams', buttonNumber: 43, imageSrc: '/image5.png', info: 'Info for Button 13',
      LogoimageSrc: '/Partners/Alshams/logo.png'
    },
    {
      partnerName: "Power Trading",
      buttonNumber: 44,
      imageSrc: "/image5.png",
      info: "Founded in 2001, Power Trading specializes in supplying advertising and promotional materials. It has a wide range of clients.",
      LogoimageSrc: "/Partners/Power Trading/logo.png"
    }
    ,
    {
      partnerName: "EverGreen",
      buttonNumber: 45,
      imageSrc: "/image5.png",
      info: "EverGreen Agricultural Contracting Company is a leading company in landscaping and green space maintenance. The company was founded in 2000 and employs a team of highly skilled agricultural engineers, managers, and agricultural workers known for their efficiency and expertise.",
      LogoimageSrc: "/Partners/EverGreen/logo.png"
    }
    ,
    {
      partnerName: "Azzam",
      buttonNumber: 46,
      imageSrc: "/image5.png",
      info: "Founded in 2018, Azzam Feed Company specializes in manufacturing feeds for third parties. The company has contracts to manufacture its products with major factories such as Rawad Feed Factory. Its main products include poultry feeds and livestock feeds, each with varying concentrations.",
      LogoimageSrc: "/Partners/Azzam/logo.png"
    },
    {
      partnerName: "Misr October",
      buttonNumber: 47,
      imageSrc: "/image5.png",
      info: "Founded in 2016, Misr October Feed Company engages in manufacturing all types of feeds. It also manufactures and presses all types of seeds, extracts and refines oils of all kinds, and packages them. The factory spans approximately 3,100 square meters and also owns multiple vehicles for product sales.",
      LogoimageSrc: "/Partners/Msr October/logo.png"
    },
    {
      partnerName: "Tolba Group",
      buttonNumber: 48,
      imageSrc: "/image5.png",
      info: "Info for Button 18",
      LogoimageSrc: "/Partners/Tolba/logo.png"
    },
    {
      partnerName: "Mosbah",
      buttonNumber: 49,
      imageSrc: "/image5.png",
      info: "Founded in 2006, Mosbah Company specializes in trading all agricultural crops including fresh vegetables and fruits. The company has obtained ISO certification and operates numerous stores, branches, and refrigerators to preserve all vegetables and fruits across the Republic's governorates.",
      LogoimageSrc: "/Partners/Mosbah/logo.png"
    },
    {
      partnerName: "AlMasa",
      buttonNumber: 50,
      imageSrc: "/image5.png",
      info: "Founded in 2013, AlMasa Packaging Materials Company operates in the field of trading food and packaging materials, distributing dry foodstuffs. It is the main supplier of packaging materials for a large number of companies such as Quedar Sweets and Al Sabeel Jadida for Poultry. Recently, the company has added a new activity in manufacturing foil dishes and food storage bags.",
      LogoimageSrc: "/Partners/Almasa/logo.png"
    },
    {
      partnerName: "Vortex",
      LogoimageSrc: "/Partners/Vortex/logo.png",
      buttonNumber: 51,
      imageSrc: "/image5.png",
      info: "Founded in 2020, Vortex Company operates in the advertising and marketing field. It packages products for companies such as Al Sweidi Cables, Crystal Asfour, and Egyptian Post. The company has a dedicated department for advertising and marketing printing."
    },
    {
      partnerName: "Instires",
      buttonNumber: 52,
      imageSrc: "/image5.png",
      info: "Founded in 2015, El Tayeb Trading and Supply Company specializes in trading and supplying tires and batteries. The company provides its services through several branches and retail stores in Greater Cairo and several other governorates, in addition to online sales.",
      LogoimageSrc: "/Partners/Instires/logo.png"
    },
    {
      partnerName: "CIT",
      LogoimageSrc: "/Partners/CIT/logo.png",
      buttonNumber: 53,
      imageSrc: "/image5.png",
      info: "Founded in 2017, CIT specializes in software development, database creation, and electronic information systems operations. The company has executed several national projects such as the Air Navigation Project, Suez Canal Authority Stadium Project, and Mansoura 1 Project in the New Administrative Capital."
    },
    {
      partnerName: "Molds Land",
      LogoimageSrc: "/Partners/MoldzLand/logo.png",
      buttonNumber: 54,
      imageSrc: "/image5.png",
      info: "Molds Land Plastic Company was established in 2017 to supply the market with various types of products. The company produces packaging for detergent, cosmetics, and disinfectants."
    },
    {
      partnerName: "Nozha",
      buttonNumber: 55,
      imageSrc: "/image5.png",
      info: "Established in 1989, Nozha Company specializes in trading medical devices, supplies, and products. The company provides healthcare services and aims to improve healthcare quality in Egypt by supplying high-quality medical equipment and supplies.",
      LogoimageSrc: "/Partners/Nozha/logo.png"
    },
    {
      partnerName: "Abdo El Amir",
      buttonNumber: 56,
      imageSrc: "/image5.png",
      info: "Abdo El Amir Company was established in 2015 and is a leading company in the field of premium car care in the Arab Republic of Egypt. The company has several branches across Egypt and collaborates with several international companies.",
      LogoimageSrc: "/Partners/Alamir/logo.png"
    },
    {
      partnerName: "Viochem",
      buttonNumber: 57,
      imageSrc: "/image5.png",
      info: "Established in 2012, Viochem Trading and Industry Company specializes in the production, blending, and trading of raw materials and flavor enhancers. The factory spans 3,550 square meters and also owns warehouses covering 1,400 square meters. The company serves clients such as Modern Foods, Big Cola, and October for Food Industries.",
      LogoimageSrc: "/Partners/Viochem/logo.png"
    },
    {
      partnerName: "Dr Ashraf",
      buttonNumber: 58,
      imageSrc: "/image5.png",
      info: "Established in 2017, Dr. Ashraf Institution specializes in supplying medical drugs and operates a center for the sale and distribution of veterinary drugs. The institution holds all necessary licenses alongside scientific and practical experiences. Its key clients include El Zahoor Company and Fit Market.",
      LogoimageSrc: "/Partners/Dr Ashraf/logo.png"
    },
    {
      partnerName: "Ashraf Gaber",
      buttonNumber: 59,
      imageSrc: "/image5.png",
      info: "Info for Button 29",
      LogoimageSrc: "/Partners/Ashraf Gaber/logo.png"
    },
    {
      partnerName: "Nogoum Alwady",
      buttonNumber: 60,
      imageSrc: "/image5.png",
      info: "Established in 2017 on 7,000 square meters, Nogoum Alwady Factory specializes in producing all poultry feed products. The company owns a complete transportation fleet to serve all governorates of Egypt. It has expertise in feed manufacturing, adhering to all quality standards, and relies on the best toxin-free plant materials and fungi.",
      LogoimageSrc: "/Partners/Nogom Alwady/logo.png"
    }];
  const [selectedButton, setSelectedButton] = useState(null);
  const [headlineDisplay, setHeadlineDisplay] = useState('block');
  const [imageDisplay, setImageDisplay] = useState('none');
  const [currentData, setCurrentData] = useState(data[0]);
  const [defaultDesDisplay, setDefaultDesDisplay] = useState('block');
  const [partnerDesDisplay, setPartnerDesDisplay] = useState('none');


  // const handleButtonClick = async (buttonNumber) => {
  //   try {

  //     // // Wrap the find operation in a Promise
  //     // const findClickedData = () => {
  //     //   return new Promise((resolve, reject) => {
  //     //     const clickedData = data.find((item) => item.buttonNumber === buttonNumber);
  //     //     if (clickedData) {
  //     //       resolve(clickedData);
  //     //     } else {
  //     //       reject(new Error('Clicked data not found'));
  //     //     }
  //     //   });
  //     // };

  //     // Use async/await to wait for the Promise to resolve
  //     // const clickedData = await findClickedData();

  //     // // Update the state to hide the default description and show partner description
  //     // setDefaultDesDisplay('none');
  //     // setPartnerDesDisplay('block');

  //     // // Update the state with the data for the clicked button
  //     // setHeadlineDisplay('none');
  //     // setCurrentData(clickedData);
  //     // setImageDisplay('block');
  //     // Set the selected button
  //     // setSelectedButton(buttonNumber);
  //   } catch (error) {
  //     console.error(error);
  //     // Handle the error as needed
  //   }
  // };

  const handleReset = () => {
    setSelectedButton(null);
    setHeadlineDisplay('block');
    setImageDisplay('none');
    setCurrentData(data[0]);
    setDefaultDesDisplay('block');
    setPartnerDesDisplay('none');
  };


  const [selectedPage, setSelectedPage] = useState(0);
  const renderCustomArrow = (direction, clickHandler, isEnabled, label) => (
    <div className={styles.arrowsContainer}>
      {direction === 'prev' && (
        <button
          className={styles.leftarrow}
          onClick={() => {
            clickHandler();
            setSelectedPage((prevPage) => (prevPage === 0 ? sectors.length - 1 : prevPage - 1));
          }}
          disabled={!isEnabled}
          aria-label={label}
        ></button>
      )}
      {/* Numbered buttons */}
      {direction !== 'prev' && (
        <div className={styles.arrows}>
          {sectors.map((_, index) => (
            <button
              key={index}
              className={`${styles.pageNumber} ${index === selectedPage ? styles.selectedPage : ''}`}
              onClick={() => setSelectedPage(index)}
            >
              {index + 1}
            </button>
          ))}
        </div>
      )}
      {direction === 'next' && (
        <button
          className={styles.rightarrow}
          onClick={() => {
            clickHandler();
            setSelectedPage((prevPage) => (prevPage === sectors.length - 1 ? 0 : prevPage + 1));
          }}
          disabled={!isEnabled}
          aria-label={label}
        ></button>
      )}
    </div>
  );

  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    // Trigger animation after the component has mounted
    setAnimate(true);
  }, []);


  return (
    <div className={styles.pageContainer}>
      <div className={styles.lefttopCont}>
        <div className={styles.headline} style={{ display: headlineDisplay }}>
          <div style={{ display: 'flex', flexDirection: 'row' }} >
            <h1 style={{ transform: animate ? 'translateY(0%)' : 'translateY(-100%)', transition: 'transform .5s' }}>S</h1>
            <h1 style={{ transform: animate ? 'translateY(0%)' : 'translateY(-200%)', transition: 'transform .5s' }}>u</h1>
            <h1 style={{ transform: animate ? 'translateY(0%)' : 'translateY(-300%)', transition: 'transform .5s' }}>c</h1>
            <h1 style={{ transform: animate ? 'translateY(0%)' : 'translateY(-400%)', transition: 'transform .5s' }}>c</h1>
            <h1 style={{ transform: animate ? 'translateY(0%)' : 'translateY(-500%)', transition: 'transform .5s' }}>e</h1>
            <h1 style={{ transform: animate ? 'translateY(0%)' : 'translateY(-600%)', transition: 'transform .5s' }}>s</h1>
            <h1 style={{ transform: animate ? 'translateY(0%)' : 'translateY(-700%)', transition: 'transform .5s' }}>s</h1>
          </div>
          <h2>Partners</h2>
        </div>
        <div className={styles.partnerlogo}>
          <img
            src={currentData.imageSrc}
            alt={`Image for Button ${currentData.buttonNumber}`}
            style={{ display: imageDisplay }}
          />

        </div>

      </div>
      <div className={styles.rightbottomCont}>

        <div className={styles.defaultdes} style={{ display: defaultDesDisplay }}>
          <div className={styles.des}  >
            <div className={styles.des1} >
              <h1>+80</h1>
              <h2>Partners</h2>
            </div>
            <div className={styles.des2} >

              <h1>
                <span style={{ color: '#DDB96E' }}>Our</span> collaborative approach ensures effective relationships, contributing to successful ventures across these diverse industries.
              </h1>
            </div>
          </div></div>
        <div className={styles.partnerdes} style={{ display: partnerDesDisplay, width: `100%` }}>
          <div className={styles.des2} >

            <h1 style={{ marginLeft: `7%` }}>
              {currentData && currentData.info}
            </h1>
          </div>

        </div>


      </div>
      {/* Carousel */}
      <Carousel
        className={styles.Carousel}
        animationHandler={fadeAnimationHandler}
        showThumbs={false}
        showStatus={false}
        infiniteLoop={true}
        showIndicators={false}
        showArrows={true} // Enable arrows
        renderArrowNext={(clickHandler1, hasNext, label) =>
          renderCustomArrow('next', clickHandler1, hasNext, label)
        }
        renderArrowPrev={(clickHandler2, hasPrev, label) =>
          renderCustomArrow('prev', clickHandler2, hasPrev, label)
        }

      >

        {sectors.map((sector, index) => (
          <div className={styles.CarouselCont} key={index} style={{ position: 'relative' }}>
            {index === 0 && (
              <>
                {/* Overlay for Manufacturing */}
                <div className={styles.overpageCont}>
                  <div className={styles.slidecontainer}>
                    <div className={styles.leftCont}>
                      <div className={styles.lefttopCont}>

                      </div>
                      <div className={styles.leftbottomCont}>
                        <div className={styles.contpartners}>
                          <div className={styles.Subcontpartners}>


                            <button
                              className={selectedButton === 1 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(1)}
                            >
                              {data[0].partnerName}
                            </button>

                            <button
                              className={selectedButton === 2 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(2)}
                            >
                              {data[1].partnerName}
                            </button>

                            <button
                              className={selectedButton === 3 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(3)}
                            >
                              {data[2].partnerName}
                            </button>

                            <button
                              className={selectedButton === 4 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(4)}
                            >
                              {data[3].partnerName}
                            </button>
                            <button
                              className={selectedButton === 5 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(5)}
                            >
                              {data[4].partnerName}
                            </button>
                          </div>
                          <div className={styles.Subcontpartners}>

                            <button
                              className={selectedButton === 6 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(6)}
                            >
                              {data[5].partnerName}
                            </button>
                            <button
                              className={selectedButton === 7 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(7)}
                            >
                              {data[6].partnerName}
                            </button>
                            <button
                              className={selectedButton === 8 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(8)}
                            >
                              {data[7].partnerName}
                            </button>
                            <button
                              className={selectedButton === 9 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(9)}
                            >
                              {data[8].partnerName}
                            </button>
                            <button
                              className={selectedButton === 10 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(10)}
                            >
                              {data[9].partnerName}
                            </button>
                          </div>
                          <div className={styles.Subcontpartners}>

                            <button
                              className={selectedButton === 11 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(11)}
                            >
                              {data[10].partnerName}
                            </button>
                            <button
                              className={selectedButton === 12 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(12)}
                            >
                              {data[11].partnerName}
                            </button>
                            <button
                              className={selectedButton === 13 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(13)}
                            >
                              {data[12].partnerName}
                            </button>
                            <button
                              className={selectedButton === 14 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(14)}
                            >
                              {data[13].partnerName}
                            </button>
                            <button
                              className={selectedButton === 15 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(15)}
                            >
                              {data[14].partnerName}
                            </button>
                          </div>

                        </div>
                      </div>
                    </div>
                    <div className={styles.rightCont}>
                      <div className={styles.righttopCont}>
                        <div className={styles.contpartners}>
                          <div className={styles.Subcontpartners}>


                            <button
                              className={selectedButton === 16 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(16)}
                            >
                              {data[15].partnerName}
                            </button>

                            <button
                              className={selectedButton === 17 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(17)}
                            >
                              {data[16].partnerName}
                            </button>

                            <button
                              className={selectedButton === 18 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(18)}
                            >
                              {data[17].partnerName}
                            </button>

                            <button
                              className={selectedButton === 19 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(19)}
                            >
                              {data[18].partnerName}
                            </button>
                            <button
                              className={selectedButton === 20 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(20)}
                            >
                              {data[19].partnerName}
                            </button>
                          </div>

                          <div className={styles.Subcontpartners}>


                            <button
                              className={selectedButton === 21 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(21)}
                            >
                              {data[20].partnerName}
                            </button>

                            <button
                              className={selectedButton === 22 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(22)}
                            >
                              {data[21].partnerName}
                            </button>

                            <button
                              className={selectedButton === 23 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(23)}
                            >
                              {data[22].partnerName}
                            </button>

                            <button
                              className={selectedButton === 24 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(24)}
                            >
                              {data[23].partnerName}
                            </button>
                            <button
                              className={selectedButton === 25 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(25)}
                            >
                              {data[24].partnerName}
                            </button>
                          </div>

                          <div className={styles.Subcontpartners}>


                            <button
                              className={selectedButton === 26 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(26)}
                            >
                              {data[25].partnerName}
                            </button>

                            <button
                              className={selectedButton === 27 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(27)}
                            >
                              {data[26].partnerName}
                            </button>

                            <button
                              className={selectedButton === 28 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(28)}
                            >
                              {data[27].partnerName}
                            </button>

                            <button
                              className={selectedButton === 29 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(29)}
                            >
                              {data[28].partnerName}
                            </button>
                            <button
                              className={selectedButton === 30 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(30)}
                            >
                              {data[29].partnerName}
                            </button>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Content of the Slide */}


              </>
            )}

            {index === 1 && (
              <>

                {/* Overlay for Trading */}
                <div className={styles.overpageCont}>
                  <div className={styles.slidecontainer}>



                    <div className={styles.leftCont}>
                      <div className={styles.lefttopCont}>

                      </div>
                      <div className={styles.leftbottomCont}>
                        <div className={styles.contpartners}>
                          <div className={styles.Subcontpartners}>


                            <button
                              className={selectedButton === 31 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(31)}
                            >
                              {data[30].partnerName}
                            </button>

                            <button
                              className={selectedButton === 32 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(32)}
                            >
                              {data[31].partnerName}
                            </button>

                            <button
                              className={selectedButton === 33 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(33)}
                            >
                              {data[32].partnerName}
                            </button>

                            <button
                              className={selectedButton === 34 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(34)}
                            >
                              {data[33].partnerName}
                            </button>
                            <button
                              className={selectedButton === 35 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(35)}
                            >
                              {data[34].partnerName}
                            </button>
                          </div>
                          <div className={styles.Subcontpartners}>

                            <button
                              className={selectedButton === 36 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(36)}
                            >
                              {data[35].partnerName}
                            </button>
                            <button
                              className={selectedButton === 37 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(37)}
                            >
                              {data[36].partnerName}
                            </button>
                            <button
                              className={selectedButton === 38 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(38)}
                            >
                              {data[37].partnerName}
                            </button>
                            <button
                              className={selectedButton === 39 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(39)}
                            >
                              {data[38].partnerName}
                            </button>
                            <button
                              className={selectedButton === 40 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(40)}
                            >
                              {data[39].partnerName}
                            </button>
                          </div>
                          <div className={styles.Subcontpartners}>

                            <button
                              className={selectedButton === 41 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(41)}
                            >
                              {data[40].partnerName}
                            </button>
                            <button
                              className={selectedButton === 42 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(42)}
                            >
                              {data[41].partnerName}
                            </button>
                            <button
                              className={selectedButton === 43 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(43)}
                            >
                              {data[42].partnerName}
                            </button>
                            <button
                              className={selectedButton === 44 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(44)}
                            >
                              {data[43].partnerName}
                            </button>
                            <button
                              className={selectedButton === 45 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(45)}
                            >
                              {data[44].partnerName}
                            </button>
                          </div>

                        </div>
                      </div>
                    </div>
                    <div className={styles.rightCont}>
                      <div className={styles.righttopCont}>
                        <div className={styles.contpartners}>
                          <div className={styles.Subcontpartners}>


                            <button
                              className={selectedButton === 46 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(46)}
                            >
                              {data[45].partnerName}
                            </button>

                            <button
                              className={selectedButton === 47 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(47)}
                            >
                              {data[46].partnerName}
                            </button>

                            <button
                              className={selectedButton === 48 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(48)}
                            >
                              {data[47].partnerName}
                            </button>

                            <button
                              className={selectedButton === 49 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(49)}
                            >
                              {data[48].partnerName}
                            </button>
                            <button
                              className={selectedButton === 50 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(50)}
                            >
                              {data[49].partnerName}
                            </button>

                          </div>

                          <div className={styles.Subcontpartners}>

                            <button
                              className={selectedButton === 51 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(51)}
                            >
                              {data[50].partnerName}
                            </button>

                            <button
                              className={selectedButton === 52 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(52)}
                            >
                              {data[51].partnerName}
                            </button>

                            <button
                              className={selectedButton === 53 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(53)}
                            >
                              {data[52].partnerName}
                            </button>

                            <button
                              className={selectedButton === 54 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(54)}
                            >
                              {data[53].partnerName}
                            </button>
                            <button
                              className={selectedButton === 55 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(55)}
                            >
                              {data[54].partnerName}
                            </button>
                          </div>

                          <div className={styles.Subcontpartners}>


                            <button
                              className={selectedButton === 56 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(56)}
                            >
                              {data[55].partnerName}
                            </button>

                            <button
                              className={selectedButton === 57 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(57)}
                            >
                              {data[56].partnerName}
                            </button>

                            <button
                              className={selectedButton === 58 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(58)}
                            >
                              {data[57].partnerName}
                            </button>

                            <button
                              className={selectedButton === 59 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(59)}
                            >
                              {data[58].partnerName}
                            </button>
                            <button
                              className={selectedButton === 60 ? styles.SelectedPartnerbutton : styles.unSelectedPartnerbutton}
                              onClick={() => handleButtonClick(60)}
                            >
                              {data[59].partnerName}
                            </button>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>


              </>
            )}

            {index === 2 && (
              <>

                {/* Overlay for Tech */}
                <div className='overlay'>





                </div>
                {/* Content of the Slide */}



              </>
            )}

            {index === 3 && (
              <>

                {/* Overlay for Transportation */}
                <div className='overlay'>

                </div>
                {/* Content of the Slide */}

              </>
            )}

            {index === 4 && (
              <>

                {/* Overlay for Construction */}
                <div className='overlay'>

                </div>
                {/* Content of the Slide */}


              </>
            )}
          </div>
        ))}

      </Carousel>

    </div>
  );
};

export default Partners;